export const GENERAL_CONFIG = {
    pagination: 10,
};
